export default "__VITE_ASSET__ded8ce14__"